export default __webpack_public_path__ + "static/media/PDF.41682d3e.svg";